import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getGeoCountry } from '../../i18n';
import AnnouncementModal from './AnnouncementModal';

export default function AnnouncementBar() {
  const { pathname } = useLocation();
  const { getActiveAnnouncement } = useAuth();
  const [data, setData] = useState(null); // { announcement, memberCount }
  const [open, setOpen] = useState(false);

  // Solo en el home.
  const onHome = pathname === '/';

  useEffect(() => {
    // Al salir del home, cerramos para que reaparezca al volver a entrar.
    if (!onHome) { setOpen(false); return; }
    let cancelled = false;
    // Resolvemos el país del visitante (geo-IP cacheada) y pedimos el anuncio
    // segmentado. Si el país no tiene anuncio, el backend devuelve null.
    getGeoCountry()
      .then((country) => (cancelled ? null : getActiveAnnouncement(country)))
      .then((res) => {
        if (cancelled || !res) return;
        setData(res);
        // El overlay aparece cada vez que el usuario ingresa al home.
        if (res?.announcement?.activo) setOpen(true);
      })
      .catch(() => { if (!cancelled) setData(null); });
    return () => { cancelled = true; };
  }, [onHome, getActiveAnnouncement]);

  const ann = data?.announcement;
  if (!onHome || !ann || !ann.activo || !open) return null;

  return (
    <AnnouncementModal
      announcement={ann}
      memberCount={data.memberCount || 0}
      onClose={() => setOpen(false)}
    />
  );
}
